import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import './Layout.css';
import { useScreenshotProtection } from '../hooks/useScreenshotProtection';

const Layout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  useScreenshotProtection();

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="layout-container">
      <Header isSidebarCollapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar} />
      <div className="layout-main">
        <Sidebar isCollapsed={isSidebarCollapsed} />
        <main className={`layout-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
